<template>
	<div class="module-progress-bar-wrapper">
		<div
			class="module-progress-bar"
			:class="'percent-' + moduleProgressPercentage"
		>
			<span class="number">{{ moduleProgressPercentage }} %</span>
			<div
				class="module-progress-bar-inner"
				:style="'width: ' + moduleProgressPercentage + '%;'"
			></div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ModuleProgressBar",
	props: ["module"],
	components: {},
	computed: {
		moduleProgressPercentage() {
			var completed = 0;
			var notCompleted = 0;
			var totalQuestions = 0;
			for (var i in this.module.resources) {
				totalQuestions =
					totalQuestions + this.module.resources[i].questions.length;
				for (var x in this.module.resources[i].questions) {
					var question = this.module.resources[i].questions[x];
					var correctAnswer = true;
					for (var y in question.answers) {
						var answer = question.answers[y];
						if (answer.correct_answer) {
							if (
								answer.answer_id !=
								question.user_answer.answer_id
							) {
								correctAnswer = false;
							}
						}
					}
					if (question.user_answer.answer == "") {
						notCompleted++;
					} else if (!correctAnswer) {
						notCompleted++;
					} else {
						completed++;
					}
				}
			}
			var completedPercentage = completed / totalQuestions;
			completedPercentage = completedPercentage * 100;
			completedPercentage = completedPercentage.toFixed();
			return completedPercentage;
		},
		activeResourceIndex() {
			return this.$store.state.meta.activeResourceIndex;
		}
	},
	methods: {},
	mounted() {}
};
</script>